import { render, staticRenderFns } from "./QuestionView.vue?vue&type=template&id=d0e8bde0&scoped=true"
import script from "./QuestionView.vue?vue&type=script&lang=js"
export * from "./QuestionView.vue?vue&type=script&lang=js"
import style0 from "./QuestionView.vue?vue&type=style&index=0&id=d0e8bde0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e8bde0",
  null
  
)

export default component.exports